import React, { useEffect, useState } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import { TailSpin } from 'react-loader-spinner';
import SftGlobalData from '../../library/SftGlobalData';
import Colors from '../../library/Colors';
import StatsTable from './StatsTable';

/**
 * Detail behind one table row: posts adminStat&action=drill {drill, params, from, to, region}
 * and renders the returned table (same shape as the tab tables) in a dialog.
 * context: {userId, group, period: {from, to, region}}
 */
export default function StatsDrillDialog({ open, onClose, drill, params, context, theme, t, showSql }) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const tr = (k, fallback) => (t ? t(k) : null) || fallback;

  useEffect(() => {
    if (!open || !drill) return;
    let alive = true;
    setLoading(true);
    setError(null);
    setData(null);
    const period = (context && context.period) || {};
    SftGlobalData.post('adminStat&action=drill', {
      sft_user_id: context ? context.userId : undefined,
      drill,
      params: params || {},
      from: period.from,
      to: period.to,
      region: period.region || '',
      include_excluded: period.withExcluded ? 1 : 0,
    }).then((response) => {
      if (!alive) return;
      if (!response || !response.success || !response.data) {
        setError((response && response.message) || tr('stats_load_error', 'Statistics could not be loaded.'));
      } else {
        setData(response.data);
      }
      setLoading(false);
    }).catch(() => {
      if (!alive) return;
      setError(tr('stats_load_error', 'Statistics could not be loaded.'));
      setLoading(false);
    });
    return () => { alive = false; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open, drill, JSON.stringify(params), context && context.period && context.period.from, context && context.period && context.period.to, context && context.period && context.period.region]);

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xl" fullWidth>
      <DialogContent className={theme} style={{ minHeight: 200 }}>
        {loading && (
          <div style={{ display: 'flex', justifyContent: 'space-evenly', marginTop: 30 }}>
            <TailSpin height="40" width="40" color={Colors.sft_blue} ariaLabel="loading" />
          </div>
        )}
        {error && <p style={{ color: '#b02a2a', padding: '8px 12px' }}>{error}</p>}
        {data && <StatsTable table={data} theme={theme} showSql={showSql} t={t} maxHeight={600} />}
      </DialogContent>
      <DialogActions className={theme}>
        <Button onClick={onClose}>{tr('stats_close', 'Sluiten')}</Button>
      </DialogActions>
    </Dialog>
  );
}
